"use client";

import { createContext, useContext } from "react";

/** Which of the three places a compound sidebar child is currently rendered
 * into — each one adapts its own markup based on this instead of the parent
 * trying to extract/clone specific children. */
export type SidebarSlot = "desktop" | "mobile-bar" | "mobile-menu";

export type SidebarContextValue = {
  slot: SidebarSlot;
  isExpandable: boolean;
  /** Whether the desktop rail is showing full content (vs collapsed to an
   * icon-only rail). Always `true` for the two mobile slots. */
  isExpanded: boolean;
  toggleSidebar: () => void;
  isMobileMenuOpen: boolean;
  closeMobileMenu: () => void;
  /** Delayed slightly after `isExpanded` flips so the width transition can
   * finish before content fades in/out. */
  showContent: boolean;
};

export const SidebarContext = createContext<SidebarContextValue | null>(null);

export const useSidebarContext = (): SidebarContextValue => {
  const ctx = useContext(SidebarContext);
  if (!ctx) {
    throw new Error(
      "Sidebar compound components (SidebarHeader/SidebarBody/SidebarFooter) must be rendered inside <Sidebar>.",
    );
  }
  return ctx;
};
